import React from "react";
import Table from "../Table";
import moment from "moment";

import formatName from "../../util/formatName";

const title = "Account Details";
const columns = [
  {
    name: "ID",
    selector: "id",
    sortable: true,
    width: "10%"
  },
  {
    name: " Name",
    selector: "accountName",
    sortable: true,
    width: "20%",
    compact: true
  },

  {
    name: " Account Number",
    selector: "accountNumber",
    sortable: true,
    width: "15%",
    compact: true
  },

  {
    name: "Balance ",
    selector: "balance.amount",
    sortable: true,
    width: "12%",
    compact: true
  },

  {
    name: "As of",
    selector: "asOf",
    sortable: true,
    width: "13%",
    compact: true,
    cell: row => {
      return (
        <span>
          {moment
            .utc(row.asOf)
            .local()
            .format("MM-DD-YYYY HH:mm")}
        </span>
      );
    }
  },

  {
    name: "Container",
    selector: "container",
    sortable: true,
    width: "10%",
    compact: true,
	  cell: row => {
		  return <span className="nameLabel">{ formatName(row.container) }</span>;
	  }
  },
  {
    name: "Type",
    selector: "accountType",
    sortable: true,
    width: "20%",
    compact: true,
    cell: row => {
      return <span title={row.accountType} className="nameLabel">{formatName(row.accountType)}</span>;
    }
  }
];

function AccountTable(props) {
  console.log(props.data);
  return (
    <Table
      title={title}
      columns={columns}
      data={props.data}
      pagination={false}
      className="accounts-table"
    />
  );
}

export default AccountTable;
